import { render, staticRenderFns } from "./DiagnosticsList.vue?vue&type=template&id=1d4853f8&scoped=true"
import script from "./DiagnosticsList.vue?vue&type=script&lang=js"
export * from "./DiagnosticsList.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticsList.vue?vue&type=style&index=0&id=1d4853f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4853f8",
  null
  
)

export default component.exports